import { Step } from "react-joyride";

const createOpportunityPageTourSteps: Step[] = [
  {
    target: ".tour-opportunity-form",
    content:
      "Fill out the form to capture the Opportunity details. We'll take you through some useful inputs.",
    skipScroll: true,
  },
  {
    target: ".tour-select-client",
    placement: "right",
    content:
      "Type here to search, or use the drop-down to select from a list of current customers.",
    skipScroll: true,
  },
  {
    target: ".tour-create-client-button",
    content: "If the Customer does not currently exist, Click here to create a new Customer. ",
    skipScroll: true,
  },
  {
    target: ".tour-opportunity-source",
    placement: "right",
    content:
      "Opportunity Source, Due At, and Estimated Value are all optional fields to help you classify and track where your sales are coming from, when the outreach should be complete, and the deal's estimated value.",
    skipScroll: true,
  },
  {
    target: ".tour-opportunity-name",
    content:
      "Give your Opportunity a name, usually associated with the Stage. Carries over to the Proposal.",
    skipScroll: true,
  },
  {
    target: ".tour-address",
    content:
      "Begin typing an address. Maps will supply suggestions for address completion. Click on ‘Manually Set Address’ to complete the address independently.",
    skipScroll: true,
  },
  {
    target: ".tour-sales-person",
    content: "Attach the opportunity to a Sales Person.",
  },
  {
    target: ".tour-products",
    content: "An optional field available to add Products the client is interested in.",
  },
  {
    target: ".tour-project-files-edit",
    content:
      "Click here to add or remove pictures and  files for this Opportunity. Files will be available to others in your organization and maintained throughout the pipeline.",
  },
  {
    target: ".tour-create-opportunity-submit",
    content: "Save and Create your Opportunity.",
  },
];

export default createOpportunityPageTourSteps;
